import JSSHA from "jssha";

/**
 * @param {string | object} input
 * @returns {string}
 */
export function sha224(input) {
  const shaObject = new JSSHA("SHA-224", "TEXT");
  shaObject.update(
    typeof input === "string" ? input : JSON.stringify(input)
  );

  return shaObject.getHash("HEX");
}
